var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFractional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F0F3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5719 21.1926L18.4281 8.82358",
    stroke: "#6A6D78",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19066 15.0081V10.3281L8.10466 10.4481V9.17006C8.32866 9.13806 8.51666 9.10206 8.66866 9.06206C8.82066 9.02206 8.98066 8.96006 9.14866 8.87606C9.31666 8.79206 9.46066 8.67606 9.58066 8.52806C9.70066 8.38006 9.79866 8.19806 9.87466 7.98206H11.2007V15.0081H9.19066Z",
    fill: "#6A6D78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9776 22.1698H17.8596L17.8236 22.0978C17.8036 22.0418 17.7936 21.7718 17.7936 21.2878C17.7936 20.7158 18.1836 20.1258 18.9636 19.5178C19.6116 18.9858 20.0736 18.5438 20.3496 18.1918C20.6256 17.8398 20.7636 17.4938 20.7636 17.1538C20.7636 16.9578 20.7196 16.7718 20.6316 16.5958C20.4756 16.2798 20.2436 16.1218 19.9356 16.1218C19.6756 16.1218 19.4556 16.1498 19.2756 16.2058L18.9876 17.4418L17.8956 17.4358L17.8056 16.0258C18.2416 15.3658 19.0756 15.0358 20.3076 15.0358C20.5876 15.0358 20.8476 15.0558 21.0876 15.0958C21.3276 15.1358 21.5576 15.2058 21.7776 15.3058C22.0016 15.4058 22.1916 15.5318 22.3476 15.6838C22.5036 15.8358 22.6276 16.0318 22.7196 16.2718C22.8116 16.5078 22.8576 16.7798 22.8576 17.0878C22.8576 17.3118 22.8216 17.5258 22.7496 17.7298C22.6816 17.9298 22.5876 18.1078 22.4676 18.2638C22.3516 18.4158 22.2116 18.5678 22.0476 18.7198C21.8836 18.8718 21.7116 19.0078 21.5316 19.1278C21.3556 19.2478 21.1656 19.3758 20.9616 19.5118C20.7616 19.6478 20.5696 19.7778 20.3856 19.9018C20.2056 20.0218 20.0236 20.1598 19.8396 20.3158C19.6596 20.4718 19.5056 20.6278 19.3776 20.7838L22.9776 20.5138V22.1698Z",
    fill: "#6A6D78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFractional);
export default __webpack_public_path__ + "static/media/Fractional.1d84489c3d1f35c9b7ffb573f924ae83.svg";
export { ForwardRef as ReactComponent };